<template>
  <div>
    <b-card no-body>
      <div class="card-padding">
        <div class="header-menu-wrapper d-flex">
          <div class="left-menu-group d-flex align-items-center">
            <span class="header__label">Escalation Events</span>
          </div>
        </div>
        <div class="filter-wrapper mt-2">
          <div class="row">
            <div class="col-12">
              <atom-multi-select
                v-model="filterList.templateName"
                title="Escalation Template"
                placeholder="All Template"
                label="name"
                :isEnableProper="false"
                :isAppendToBody="false"
                :option="escalationTemplateOptions"
              ></atom-multi-select>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12 col-md-6">
              <atom-multi-select
                v-model="filterList.level"
                title="Escalated to Level"
                placeholder="Select Level"
                label="name"
                :isEnableProper="false"
                :isAppendToBody="false"
                :option="escalationLevelsList"
              ></atom-multi-select>
            </div>
            <div class="col-12 col-md-3 mt-1 mt-md-0">
              <atom-input
                v-model="filterList.ntdcId"
                :title="contractIdLabel"
                :placeholder="contractIdLabel"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
            <div class="col-12 col-md-3 mt-1 mt-md-0">
              <atom-input
                v-model="filterList.ticketId"
                title="Ticket ID"
                placeholder="Ticket ID"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
          </div>

          <div class="row mt-1">
            <div class="col-12 col-md-6">
              <atom-multi-select
                v-model="filterList.escalateBy"
                title="Escalate By"
                placeholder="Escalate By"
                label="name"
                :isEnableProper="false"
                :isAppendToBody="false"
                :option="userOptions"
              ></atom-multi-select>
            </div>
            <div class="col-12 col-md-6 mt-1 mt-md-0">
              <atom-multi-select
                v-model="filterList.customerName"
                title="Customer Name"
                placeholder="Customer Name"
                label="name"
                :isEnableProper="false"
                :isAppendToBody="false"
                :option="customerNameOptions"
              ></atom-multi-select>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12 col-md-6 col-lg-3 w-100 mt-1 mt-lg-0">
              <div>
                <atom-datepicker
                  datepickerId="molecule-date-picker-period--start"
                  title="Start Date"
                  v-model="filterList.dateTime.start"
                  :maxDate="
                    filterList.dateTime.end
                      ? filterList.dateTime.end
                      : filterList.dateTime.now
                  "
                  type="dateNtime"
                  placeholder="Select Start Date"
                  class="molecule-date-picker-period--start"
                  :isDisabled="!filterList.isEnableDate"
                ></atom-datepicker>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 w-100 mt-1 mt-lg-0">
              <div>
                <atom-datepicker
                  datepickerId="molecule-date-picker-period--end"
                  title="End Date"
                  v-model="filterList.dateTime.end"
                  :minDate="filterList.dateTime.start"
                  :maxDate="filterList.dateTime.now"
                  type="dateNtime"
                  placeholder="Select End Date"
                  class="molecule-date-picker-period--end"
                  :isDisabled="!filterList.isEnableDate"
                ></atom-datepicker>
              </div>
            </div>

            <div
              class="col-12 col-lg-6 mt-1 mt-lg-0 d-flex align-items-end justify-content-end justify-content-lg-start"
            >
              <div class="d-flex flex-column">
                <label>Filter Date?</label>
                <atom-switch
                  v-model="filterList.isEnableDate"
                  class="filter__switch"
                ></atom-switch>
              </div>
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button ml-1"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row mt-1">
        <div class="col-12 table-wrapper">
          <b-table
            sticky-header
            responsive
            hover
            :items="items"
            :fields="fields"
            @row-clicked="selectRow"
            show-empty
          >
            <template #cell(templateName)="data">
              <div class="custom-template-name-wrapper">
                <span class="text-medium-black">{{ data.value }}</span>
              </div>
            </template>
            <template #cell(level)="data"
              ><span class="text-semibold-black">
                LEVEL {{ data.item.level.order }}
              </span>
              <div>
                <span class="text-regular-grey font-size-12">
                  {{ data.item.level.name }}
                </span>
              </div>
            </template>
            <template #cell(escalationDate)="data">
              <div class="d-flex">
                <span>
                  {{ data.item.escalationDate.date }}
                </span>
              </div>
              <div>
                <span class="text-regular-grey font-size-12">
                  {{ data.item.escalationDate.time }}
                </span>
              </div>
            </template>
            <template #cell(issueId)="data">
              <div class="d-flex">
                <span class="text-medium-black">
                  {{ data.item.issueId.ntdcId }}
                </span>
              </div>
              <div>
                <span class="text-color-grey">
                  {{ data.item.issueId.ticketId }}
                </span>
              </div>
            </template>
            <template #cell(escalateBy)="data">
              <div class="d-flex">
                <span class="text-semibold-black">
                  {{ data.item.escalateBy.name }}
                </span>
              </div>
              <div>
                <span> ({{ data.item.escalateBy.role }}) </span>
              </div>
            </template>
            <template #empty>
              <div
                class="d-flex flex-column align-items-center justify-content-center my-4"
              >
                <feather-icon
                  icon="CloudOffIcon"
                  class="empty-data__icon"
                ></feather-icon>
                <label class="empty-data__text--title">No Data</label>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <molecule-pagination-with-per-page
        :page="filterList.currentPage"
        :total-count="filterList.totalCount"
        :per-page="filterList.perPage"
        @onUpdatePaginationOrPerPage="onUpdatePaginationOrPerPage"
      ></molecule-pagination-with-per-page>
    </b-card>
    <footer style="padding-top: 1px"></footer>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive"
import { BCard, BTable, BPagination } from "bootstrap-vue"

import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import MoleculePaginationWithPerPage from "@/components/molecules/MoleculePaginationWithPerPage.vue"
import mixins from "@/mixins"

export default {
  name: "OrganismEscalationEvents",
  components: {
    BCard,
    BTable,
    BPagination,
    AtomButton,
    AtomDatepicker,
    AtomInput,
    AtomMultiSelect,
    AtomSwitch,
    MoleculePaginationWithPerPage,
  },
  mixins: [mixins],
  directives: {
    Ripple,
  },
  props: {
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    filterList: {
      required: true,
      type: Object,
    },
    escalationTemplateOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    customerNameOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    userOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["onUpdateFilterData", "onSetDefaultFilterData"],
  data() {
    return {
      escalationLevelsList: [],
      levelLimit: 8,
    }
  },

  mounted() {
    this.generateLevelList()
  },

  methods: {
    generateLevelList() {
      this.escalationLevelsList = []
      for (let i = 1; i <= this.levelLimit; i++) {
        this.escalationLevelsList.push({
          id: i,
          name: `Level ${i}`,
        })
      }
    },
    gotoEscalationTemplate() {
      this.navigateTo("/internal/web-portal/escalation/template")
    },

    goToTicketTracking() {
      this.navigateTo("/internal/web-portal/ticket")
    },

    selectRow(row) {
      const ticketId = row.issueId.ticketId
      this.navigateTo(`/internal/web-portal/ticket/${ticketId}`)
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    clickButtonSearch() {
      this.filterList.currentPage = 1
      this.$emit("onUpdateFilterData", this.filterList)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    onUpdatePaginationOrPerPage(currentPerPage, currentPage) {
      const updatedFilter = {
        ...this.filterList,
        currentPage,
        perPage: currentPerPage,
      }
      this.$emit("onUpdateCurrentPageOrPerPage", updatedFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper ::v-deep.b-table-sticky-header {
  min-height: 500px;
  max-height: calc(100vh - 675px);
  &:has(.b-table-empty-row) {
    min-height: 350px;
  }
}

.card-padding {
  padding: 21px;
}

.card-padding-x {
  padding-left: 21px;
  padding-right: 21px;
}

.card-padding-y {
  padding-top: 21px;
  padding-bottom: 21px;
}

.card-padding-top {
  padding-top: 21px;
}

.card-padding-bottom {
  padding-bottom: 21px;
}

.active-menu {
  padding: 8px 21px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  background: #7367f0;
  border-radius: 5px;
  box-shadow: 0px 4px 18px -4px rgba(115, 103, 240, 0.65);
}

.menu-link {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

.custom-template-name-wrapper {
  width: 170px;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}
</style>
